/**
 * Constants.ts
 *
 * Module to hold userFact-related constants
 */

export const AppUsageUserFactType = "AppUsage";

export enum ComparatorType {
	Equal = 0,
	NotEqual,
	GreaterThan,
	GreaterThanOrEqual,
	LessThan,
	LessThanOrEqual,
}

export const AppLastUsedEventNames: { [appId: number]: string } = {
	2155: "WordWebLastUsed",
	2156: "ExcelWebLastUsed",
	2157: "PowerPointWebLastUsed",
};

